import enLang from './lang/en';
import zhCNLang from './lang/zh-CN';

export default {
    en: enLang,
    'zh-CN': zhCNLang,
}